import { Params } from '@angular/router';

import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';
import { TeacherStudentsQueryParamsModel } from 'app/teacher/students/models/teacher-students-query-params.model';

export const STUDENTS_ROUTE = {
  name: 'students',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },
  queryParams(params: TeacherStudentsQueryParamsModel): Params {
    return {
      acceptstudent: params.acceptStudent,
      declinestudent: params.declineStudent,
      showgettingstarted: params.showGettingStarted,
      externalid: params.externalId,
      createstudents: params.createStudents
    };
  }
};
